module.exports = __webpack_public_path__ + "static/displayPicSmall-00c570bcd539947d998951302b67deba.jpg";